<template>
  <CollectivityPicker
    :is-loading="loadingCollectivities > 0"
    :get-collectivities="fetchCollectivities"
    :collectivities="collectivities"
    :stay-on-page="stayOnPage"
  />
</template>

<script>
import { CycleCollectivityPicker } from '@aon/cycle'
import { mapValues } from 'lodash'
import axios from 'axios'
import config from '@/temp/config'

export default {
  name: 'CycleCollectivityPickerSitecore',
  components: {
    CollectivityPicker: CycleCollectivityPicker
  },
  provide() {
    return { textContent: this.textContent }
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    collectivities: [],
    loadingCollectivities: 0,
    searchTerm: '',
    pageNumber: 1,
    skipQuery: true
  }),
  computed: {
    textContent() {
      return mapValues(this.fields, (item) => item.value ?? item)
    },
    areCollectivitiesIncluded() {
      return this.params?.includeCollectivities === '1'
    },
    areHealthPartnersIncluded() {
      return this.params?.includeHealthPartners === '1'
    },
    stayOnPage() {
      return this.params?.stayOnPage === '1'
    }
  },
  methods: {
    mapCollectivityItem(item) {
      if (item?.name && item?.url) {
        const { name, url } = item

        const isInternalUrl = url.startsWith('/partners')
        const isEnglishUrl = window.location.pathname.startsWith('/en')
        const hasHttpProtocol = /^https?:\/\//i.test(url)

        let finalUrl = url
        if (isInternalUrl) {
          if (isEnglishUrl) finalUrl = `/en${url}`
        } else if (!hasHttpProtocol) {
          finalUrl = `https://${url}`
        }

        return {
          collectivityGuid: name,
          collectivityName: name,
          collectivityType: {
            name,
            description: '',
            url: finalUrl,
            link: {
              __typename: 'Link',
              href: finalUrl,
              linkType: isInternalUrl ? 'internal' : 'external'
            }
          },
          deepLink: finalUrl
        }
      }
      return false
    },
    fetchCollectivities(searchTerm) {
      if (!searchTerm || searchTerm.length < 3 || typeof searchTerm !== 'string') {
        return
      }
      this.loadingCollectivities = 1

      axios({
        url: `${config.collectivityApiHost}/health-collectivity/search`,
        params: {
          key: searchTerm
        },
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => {
          this.collectivities = response.data.map(this.mapCollectivityItem)
          this.loadingCollectivities = 0
        })
        .catch((error) => {
          console.error('Error fetching collectivities:', error)
          this.loadingCollectivities = 0
        })
    }
  }
}
</script>
